import { LoadingManager } from "@core/managers/loading.manager";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { StripeService } from "@core/services";
import { ETAB_ROUTES } from "@etab/config";
import { META_HTML_TITLE } from "@core/constants";
import { ACTION_ACCOUNT_INIT } from "@etab/stores/types";
import { useProfileStore } from "@etab/stores/profile";

import PaymentRoot from "./Payment.root.vue";
import PaymentCardsPage from "./PaymentCards.page.vue";
import AddCardPage from "./AddCard.page.vue";
import IbanPage from "./Iban.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.payment.root.path,
      name: ETAB_ROUTES.payment.root.name,
      redirect: { name: ETAB_ROUTES.payment.cards.name },
      meta: { [META_HTML_TITLE]: "ETAB.PAGES.PAYMENT.@TITLE" },
      component: PaymentRoot,
      children: [
        {
          path: ETAB_ROUTES.payment.cards.path,
          name: ETAB_ROUTES.payment.cards.name,
          component: PaymentCardsPage,
        },
        {
          path: ETAB_ROUTES.payment.addCard.path,
          name: ETAB_ROUTES.payment.addCard.name,
          component: AddCardPage,
          async beforeEnter(to, from, next) {
            if (!from.name) {
              return next({ name: ETAB_ROUTES.userMenu.root.name });
            }
            await StripeService.loadStripe();
            return next();
          },
        },
        {
          path: ETAB_ROUTES.payment.addAndPay.path,
          name: ETAB_ROUTES.payment.addAndPay.name,
          component: AddCardPage,
          async beforeEnter(to, from, next) {
            await StripeService.loadStripe();
            return next();
          },
        },
        {
          path: ETAB_ROUTES.payment.iban.path,
          name: ETAB_ROUTES.payment.iban.name,
          component: IbanPage,
          async beforeEnter(to, from, next) {
            const profileStore = useProfileStore();
            const allowedRoutes = [
              ETAB_ROUTES.dashboard.recruitment.temporary.candidate.profile.name, // AE candidate selection page
              ETAB_ROUTES.account.adminFolderStatus.name, // Admin folder synthesis page
            ];
            // prevent user accessing this route directly as we need to make sure comes from admin folder status page
            if (!allowedRoutes.includes(from.name)) {
              return next({ name: ETAB_ROUTES.account.adminFolderStatus.name });
            }
            try {
              LoadingManager.show();
              await profileStore[ACTION_ACCOUNT_INIT]();
              await StripeService.loadStripe();
              return next();
            } catch (error) {
              NotificationsManager.contactEtabSupport();
              LoadingManager.hide();
              return next({ name: ETAB_ROUTES.account.adminFolderStatus.name });
            }
          },
        },
      ],
    },
  ];
}
